import {removeAlphaFromDataUrl} from "../helpers/pngHelpers";
import {getCombinedLidSize, getLidSizes} from "../containers/domain/lid";
import {getIntermediateCeilingSize} from "../containers/domain/intermediateCeiling";
import {Plan} from "../types";
import {getVaultSize} from "../containers/domain/vault";
import {getFloorSize} from "../containers/domain/floor";

export const prepareImages = (plan: Plan, planImages: any) => ({
    ...(!!plan.lid && {lidGroundView: removeAlphaFromDataUrl(planImages.lidGroundView)}),
    ...(
        !!plan.intermediateCeiling && !plan.lid
            ? {intermediateCeilingGroundView: removeAlphaFromDataUrl(planImages.intermediateCeilingGroundView)}
            : {}
    ),
    ...(!!plan.floor && {floorGroundView: removeAlphaFromDataUrl(planImages.floorGroundView)}),
    sideAElevationView: removeAlphaFromDataUrl(planImages.sideAElevationView),
    sideBElevationView: removeAlphaFromDataUrl(planImages.sideBElevationView),
    sideCElevationView: removeAlphaFromDataUrl(planImages.sideCElevationView),
    sideDElevationView: removeAlphaFromDataUrl(planImages.sideDElevationView)
})

export const prunePlan = (plan: Plan) => {
    const {dirty, ...others} = plan

    return others;
}

export const computeDerived = (plan: Plan) => {
    return {
        lid: plan.lid && {
            combinedSize: pruneLidSize(getCombinedLidSize(plan)),
            sizes: getLidSizes(plan).map(pruneLidSize)
        },
        intermediateCeiling: plan.intermediateCeiling && {
            size: pruneSize(getIntermediateCeilingSize(plan))
        },
        vault: plan.vault && {size: pruneSize(getVaultSize(plan, true))},
        floor: plan.floor && {size: pruneSize(getFloorSize(plan))}
    }
}

interface Size {
    length: number;
    width: number;
    height: number;
    x: number;
    y: number;
}

const pruneSize = (size: any): Size => ({
    length: Math.round(size.length * 10) / 10,
    width: Math.round(size.width * 10) / 10,
    height: Math.round(size.height * 10) / 10,
    x: Math.round(size.x * 10) / 10,
    y: Math.round(size.y * 10) / 10
})

interface LidSize {
    length: number;
    width: number;
    height: number;
    x: number;
    y: number;
    manholeIds: string[];
}

const pruneLidSize = (size: any): LidSize => ({
    length: Math.round(size.length * 10) / 10,
    width: Math.round(size.width * 10) / 10,
    height: Math.round(size.height * 10) / 10,
    x: Math.round(size.x * 10) / 10,
    y: Math.round(size.y * 10) / 10,
    manholeIds: size.manholeIds
})
